import "./SpecialOffer.css";

import { useUiKitComponents } from "@qws-org/ui-kit";
import type { FC } from "react";

import { useClientContext } from "~/contexts/client-context";
import type { DetailedSpecialOffer } from "~/core/deprecated/special-offers";

export type Props = {
  specialOffers: Array<DetailedSpecialOffer>;
  featureFlags: {
    isSpecialOffersButtonEnabled: boolean;
  };
};

/**
 * @deprecated
 */
export const SpecialOffers: FC<Props> = (data) => {
  const { language } = useClientContext();
  const { Link } = useUiKitComponents();

  return (
    <section className="special-offers-section">
      <div className="section-content">
        <div className="header">
          <h2 className="desktop-only">{"Features"}</h2>
          <h2 className="mobile-only">{"Our other bonuses"}</h2>
          {data.featureFlags.isSpecialOffersButtonEnabled && (
            <Link href="/promotions" className="button show-all-button">
              {"Show all"}
            </Link>
          )}
        </div>
        <ul className="special-offers">
          {data.specialOffers.map((offer, i) => {
            return (
              <li key={i} className="special-offer">
                <Link href={`${offer.url}`}>
                  <img
                    src={offer.image[language]}
                    alt={offer?.name ? offer.name[language] : ""}
                  />
                </Link>
                {offer?.name && (
                  <div className="offer-name">{offer.name[language]}</div>
                )}
              </li>
            );
          })}
        </ul>
        {data.featureFlags.isSpecialOffersButtonEnabled && (
          <div className="footer">
            <Link href="/promotions" className="button show-all-button">
              {"Show all"}
            </Link>
          </div>
        )}
      </div>
    </section>
  );
};
